/* eslint-disable */
import {PAGE_TYPE_MAP} from "@/js/common/services/DataLayerService";

var funnelPage = window.funnelPage,
	pageType;

function getPage() {
	var pathname = window.location.pathname;
	var reg = /\.html/;
	var htmlIndex = pathname.search(reg);
	var staticPage;

	if (htmlIndex !== -1) {
		staticPage = pathname.substr(1, htmlIndex - 1);
	} else {
		var parts = pathname.split('/').filter(function(part) {
			return part !== '';
		});
		staticPage = parts.length > 0 ? parts[parts.length - 1] : 'unknown-page';
	}

	staticPage = staticPage || 'unknown-page';
	return staticPage;
}

let getPageTypeService = function() {
	if (funnelPage) {
		pageType = funnelPage;
	} else {
		pageType = getPage();
	}

	return PAGE_TYPE_MAP[pageType] ?? pageType;
};

export default getPageTypeService;